import React, { useContext } from 'react';
import { OidcIdentityContext } from '@rsmus/react-auth';
import { Header } from './Header/Header'
import appLogo from 'cui/assets/images/insight-icon.svg'
import { User } from 'oidc-client-ts';

import SharedLayout from './SharedLayout';

const appInfo:any  = {
	app: "In",
	logo: appLogo,
	xp: "Sight"
}
const userActions: any = [{
	text: "Setting",
	url: "/setting"
}]

const PageLayout = () => {
	const { user, logout } = useContext(OidcIdentityContext);
	
	return (
		<>
			<Header
				appTitle={appInfo}
				user={user as User}
				logout={logout}
			/>
			<SharedLayout maxWidth={undefined}
				isNavigationBarEnabled
				headerUserActionLinks={userActions}
			/>
		</>
	)
}

export default PageLayout;
